import type { GoogleFontWithWeights } from "../../Store/types";

export interface CustomFontPayload {
  fallback_font: string;
  font_family: string;
  font_type: "google" | "custom";
  variants: string;
}

/**
 * Converts Google Fonts with weights to custom font payload format
 * @param googleFonts - Array of Google fonts with their weights
 * @returns Array of custom font payload objects
 */
export const createGoogleFontsPayload = (
  googleFonts: GoogleFontWithWeights[],
): CustomFontPayload[] =>
  googleFonts.map(font => ({
    font_family: font.family,
    variants: Array.from(font.weights).join(","),
    fallback_font:
      "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    font_type: "google" as const,
  }));
